import React from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";
import FieldWrapper from "./FieldWrapper";
import TenthTwelthBoard from "./Fields/TenthTwelthBoard";
import TenthTwelthPassingYear from "./Fields/TenthTwelthPassingYear";
import TenthTwelthPercentage from "./Fields/TenthTwelthPercentage";
import {FormUl} from "./loaderStyled";

const CurrentEducationUGSection: React.FC = () => {
    const bachelorFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields,
    );

    return (
        <FormUl>
            {bachelorFields?.tenthPassingYear && (
                <FieldWrapper
                    visible={bachelorFields.tenthPassingYear.visible}
                    addEmptyLi={true}
                    loading={bachelorFields.tenthPassingYear.loading ?? false}
                >
                    <TenthTwelthPassingYear configuration={bachelorFields.tenthPassingYear} />
                </FieldWrapper>
            )}
            {bachelorFields?.tenthTwelfthPassingBoard && (
                <FieldWrapper
                    visible={bachelorFields.tenthTwelfthPassingBoard.visible}
                    loading={bachelorFields.tenthTwelfthPassingBoard.loading ?? false}
                >
                    <TenthTwelthBoard configuration={bachelorFields.tenthTwelfthPassingBoard} />
                </FieldWrapper>
            )}
            {bachelorFields?.tenthTwelfthPercentage && (
                <FieldWrapper
                    visible={bachelorFields.tenthTwelfthPercentage.visible}
                    loading={bachelorFields.tenthTwelfthPassingBoard.loading ?? false}
                    loaderType="Range Input"
                >
                    <TenthTwelthPercentage configuration={bachelorFields.tenthTwelfthPercentage} />
                </FieldWrapper>
            )}
        </FormUl>
    );
};

export default CurrentEducationUGSection;
